import * as React from 'react';
import { Result } from './result';
import { IEventSearchResultHitDTO, ISearchResultHitDTO } from '../../DTO/search';
import { EventResult } from '../events/event-result';
import { IContentProps } from '../../models/content-props';
import { LoadingSpinner } from '../loading-spinner/loading-spinner';

interface IProps {
    results: ISearchResultHitDTO[];
    onResultClick: (hitId: string) => void;
    isEventList: boolean;    
    contentProps: IContentProps;
    isArchived: boolean;
    eventListFeaturedEvents: ISearchResultHitDTO[];
    isLoading: boolean;
}

export function ResultList({ results, onResultClick, isEventList, contentProps, eventListFeaturedEvents = [], isArchived = false, isLoading = false}: IProps) {
    
    const eventListFeaturedEventsResults = ((result: ISearchResultHitDTO, index: number) => {        
        return <EventResult result={result as IEventSearchResultHitDTO} key={`featured-event ${result.url} ${result.title} ${index}`} onClick={onResultClick} contentProps={contentProps}  isArchived={isArchived} isFeatured={true}/>        
    });
    
    const renderResults = ((result: ISearchResultHitDTO, index: number) => {
        if (isEventList) {
            return <EventResult result={result as IEventSearchResultHitDTO} key={`${result.url} ${result.title} ${index}`} onClick={onResultClick} contentProps={contentProps} isArchived={isArchived} isFeatured={false}/>

        } else {
            return <Result result={result} key={`${result.url} ${result.title} ${index}`} onClick={onResultClick} />
        }
    });

    return (
        <>
            {isEventList && isLoading ?
                <LoadingSpinner />
            : 
             <>
                 {(isEventList && eventListFeaturedEvents.length > 0 && !isArchived) &&
                     <ul className="adage-search-results featured-events" aria-live="polite">
                         {eventListFeaturedEvents.map(eventListFeaturedEventsResults)}
                    </ul>
                 }      
                 <ul className="adage-search-results" aria-live="polite">
                     {results.map(renderResults)}
                 </ul>
             </>
            }
        </>
    )
};
